<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <div class="layout-sidebar" @click="onSidebarClick">
      <TokenTimer @tokenExpired="onTokenExpired" />
      <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
    </div>

    <Toast />
    <div class="layout-main-container">
      <div class="layout-main">
        <router-view />
      </div>
      <AppFooter />
    </div>

    <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
    <transition name="layout-mask">
      <div
        class="layout-mask p-component-overlay"
        v-if="mobileMenuActive"
      ></div>
    </transition>
  </div>
</template>

<script>
//COMPONENTS
import AppTopBar from "./components/menu/AppTopbar.vue";
import AppMenu from "./components/menu/AppMenu.vue";
import AppConfig from "./components/menu/AppConfig.vue";
import AppFooter from "./components/menu/AppFooter.vue";
import TokenTimer from "./components/menu/TokenTimer.vue";

export default {
  emits: ["change-theme"],
  data() {
    return {
      user: [],
      layoutMode: "static",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: [
        {
          label: "Principal",
          items: [
            {
              label: "Calendário",
              icon: "pi pi-fw pi-calendar",
              to: "/",
            },
          ],
        },
        {
          label: "Eventos",
          visible: () => {
            return (
              this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
              (this.findPermission("ROLE_EVENTO_ATUALIZAR_EVENTO") ||
                this.findPermission("R-EVT165"))
            );
          },
          items: [
            {
              label: "Gerenciamento de Eventos",
              icon: "pi pi-fw pi-check-circle",
              to: "/eventos",
            },
          ],
        },
        {
          label: "Administração do Sistema",
          visible: () => {
            return (
              this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
              (this.findPermission("ROLE_EVENTO_REMOVER_RESPONSIBLE") ||
                this.findPermission("ROLE_EVENTO_REMOVER_EQUIPAMENTO") ||
                this.findPermission("ROLE_EVENTO_REMOVER_LOCAL") ||
                this.findPermission("R-EVT169") ||
                this.findPermission("R-EVT164") ||
                this.findPermission("R-EVT166"))
            );
          },
          items: [
            {
              label: "Gestão de Responsáveis",
              icon: "pi pi-fw pi-user",
              to: "/responsavel",
              visible: () => {
                return (
                  this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
                  (this.findPermission("ROLE_EVENTO_REMOVER_RESPONSIBLE") ||
                    this.findPermission("R-EVT169"))
                );
              },
            },

            {
              label: "Gestão de Equipamentos",
              icon: "pi pi-fw pi-desktop",
              to: "/equipamentos",
              visible: () => {
                return (
                  this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
                  (this.findPermission("ROLE_EVENTO_REMOVER_EQUIPAMENTO") ||
                    this.findPermission("R-EVT164"))
                );
              },
            },
            {
              label: "Gerenciamento de Locais",
              icon: "pi pi-fw pi-table",
              to: "/locais",
              visible: () => {
                return (
                  this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
                  (this.findPermission("ROLE_EVENTO_REMOVER_LOCAL") ||
                    this.findPermission("R-EVT166"))
                );
              },
            },
          ],
        },

        {
          label: "Gerenciamento de Log",
          visible: () => {
            return (
              this.checkGroupPermission("ADMINISTRADOR_EVENTOS") &&
              (this.findPermission("ROLE_EVENTO_REMOVER_LOCAL") ||
                this.findPermission("R-EVT166"))
            );
          },
          items: [
            {
              label: "Log",
              icon: "pi pi-fw pi-user",
              to: "/log",
            },
          ],
        },
      ],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
      if (this.$route.meta?.isAdm) {
        if (!this.checkGroupPermission("ADMINISTRADOR_EVENTOS"))
          this.$router.push("/acesso-negado");
      }
    },
  },
  created() {
    this.checkCookieSession();
  },
  methods: {
    checkCookieSession() {
      let cookieToken = this.getCookie("access_token");
      let cookieLocal = this.getCookie("local");
      //VERIFICA SE POSSUE TOKEN NO COOKIE DO NAVEGADOR
      if (cookieToken && cookieLocal) {
        this.$store.dispatch("setUserLogged");
        this.user = this.$store.getters.getUserLogged;

        return true;
      } else {
        alert("Usuário desconectado! Você precisa fazer login novamente");
        return false;
      }
    },
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        let [key, value] = cookie.split("=");
        if (key === name) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
    checkGroupPermission(p) {
      if (this.user.services) {
        let isPermited = this.user.services.filter(
          (a) => a.groupPermission == p
        );
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    findPermission(p) {
      if (this.user.authorities) {
        let isPermited = this.user.authorities.filter((a) => a == p);
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
      }

      return true;
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
        },
      ];
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
    AppConfig: AppConfig,
    AppFooter: AppFooter,
    TokenTimer,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
